import * as styles from 'styles/pages/Styleguide.css'

const SGTextThemes = () => (
  <section className={ styles.sgSection }>
    <article>
      <div>
        <div>Dolor amet shank pork chop</div>
        <p>Bacon ipsum dolor amet shank pork chop jowl <a>frankfurter</a> andouille short ribs bresaola ribeye porchetta tail drumstick kevin bacon flank turducken.</p>
      </div>
      <div className='caption'>midnight</div>
      <div>
        <div>Dolor amet shank pork chop</div>
        <p>Bacon ipsum dolor amet shank pork chop jowl <a>frankfurter</a> andouille short ribs bresaola ribeye porchetta tail drumstick kevin bacon flank turducken.</p>
      </div>
      <div className='caption'>dusk</div>
    </article>
    <br />
    <article>
      <div>
        <div>Dolor amet shank pork chop</div>
        <p>Bacon ipsum dolor amet shank pork chop jowl <a>frankfurter</a> andouille short ribs bresaola ribeye porchetta tail drumstick kevin bacon flank turducken.</p>
      </div>
      <div className='caption'>dawn</div>
    </article>
    <br />
    <article>
      <div>
        <div>Dolor amet shank pork chop</div>
        <p>Bacon ipsum dolor amet shank pork chop jowl <a>frankfurter</a> andouille short ribs bresaola ribeye porchetta tail drumstick kevin bacon flank turducken.</p>
      </div>
      <div className='caption'>noon</div>
    </article>
  </section>
)

export default SGTextThemes
